import React, { useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { useNavigate } from 'react-router-dom';
import LeyendaAcotaciones from '../components/LeyendaAcotaciones';
import Loader from '../components/Loader';
import '../styles/MapaPanel.css'; 

const containerStyle = { width: '100%', height: '100vh' };
const center = { lat: 18.141989946752716, lng: -94.41141640412994 };
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';

const iconosPorTipo = {
  agroindustria: '/assets/tractor.png',
  papel: '/assets/paper-roll.png',
  quimica: '/assets/industry.png',
  puerto: '/assets/cruise.png',
};


const ctaBoxStyle = {
  position: 'absolute', bottom: '30px', right: '20px', 
  backgroundColor: 'white', padding: '20px', borderRadius: '12px',
  boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 5, maxWidth: '280px', textAlign: 'left',
};

const ctaLinkStyle = {
  display: 'inline-block', marginTop: '12px', padding: '10px 15px',
  backgroundColor: '#007bff', color: 'white', textDecoration: 'none',
  borderRadius: '6px', fontWeight: 'bold', border: 'none', cursor: 'pointer', width: '100%'
};

function Mapa() {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;
  const [locaciones, setLocaciones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [selectedLugar, setSelectedLugar] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/lugar`)
      .then((res) => res.json())
      .then((data) => setLocaciones(Array.isArray(data) ? data : []))
      .catch((err) => console.error('Error en fetch:', err))
      .finally(() => setCargando(false));
  }, []);

  if (cargando) return <Loader message="Cargando mapa..." />;

  return (
    <div style={{ position: 'relative' }}>
      <LoadScript googleMapsApiKey={apiKey}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={12}
          options={{ streetViewControl: false, mapTypeControl: false, fullscreenControl: false }}
          onClick={() => setSelectedLugar(null)} // Click en mapa cierra el panel
        >
          {locaciones.map((loc) => (
            <Marker
              key={loc.id}
              position={{ lat: Number(loc.latitud), lng: Number(loc.longitud) }}
              icon={{
                url: iconosPorTipo[loc.tipoIndustria] || '/assets/tractor.png',
                scaledSize: { width: 32, height: 32 },
              }}
              onClick={() => setSelectedLugar(loc)}
            />
          ))}
        </GoogleMap>
      </LoadScript>

      <LeyendaAcotaciones />

      <div style={ctaBoxStyle}>
        <h4 style={{ margin: '0 0 8px 0', color: '#333' }}>¿Tienes una empresa?</h4>
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>Regístrala para aparecer en el mapa.</p>
        <button onClick={() => navigate('/formulario-empresa')} style={ctaLinkStyle}>
          Registrar mi empresa
        </button>
      </div>

      {/* --- PANEL LATERAL MODERNO --- */}
      {selectedLugar && (
        <>
          {/* Backdrop oscuro para enfocar la atención */}
          <div className="panel-backdrop" onClick={() => setSelectedLugar(null)} />

          <div className="side-panel">
            {/* Header con Imagen y Botón Cerrar */}
            <div className="panel-header">
              <button className="close-btn" onClick={() => setSelectedLugar(null)} title="Cerrar">
                ✕
              </button>
              <img 
                className="panel-image"
                src={`https://maps.googleapis.com/maps/api/streetview?size=600x400&location=${selectedLugar.latitud},${selectedLugar.longitud}&key=${apiKey}`}
                alt="Vista del lugar"
                onError={(e) => e.target.src = 'https://via.placeholder.com/600x400?text=Sin+Imagen+Disponible'}
              />
            </div>

            <div className="panel-content">
              <span className="panel-category">{selectedLugar.tipoIndustria}</span>
              <h2 className="panel-title">{selectedLugar.nombre}</h2>
              
              {selectedLugar.descripcion && (
                <p className="panel-description">{selectedLugar.descripcion}</p>
              )}

              <div className="contact-section">
                {selectedLugar.direccion && (
                  <div className="contact-item">
                    <span className="contact-icon">📍</span>
                    <div className="contact-text">
                      <span className="contact-label">DIRECCIÓN</span>
                      {selectedLugar.direccion}
                    </div>
                  </div>
                )}

                {selectedLugar.telefono && (
                  <div className="contact-item">
                    <span className="contact-icon">📞</span>
                    <div className="contact-text">
                      <span className="contact-label">TELÉFONO</span>
                      <a href={`tel:${selectedLugar.telefono}`} className="contact-link">
                        {selectedLugar.telefono}
                      </a>
                    </div>
                  </div>
                )}

                {selectedLugar.correoElectronico && (
                  <div className="contact-item">
                    <span className="contact-icon">✉️</span>
                    <div className="contact-text">
                      <span className="contact-label">CORREO ELECTRÓNICO</span>
                      <a href={`mailto:${selectedLugar.correoElectronico}`} className="contact-link">
                        {selectedLugar.correoElectronico}
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Mapa;


